import { Directive, Input, computed, signal } from '@angular/core';
import { IFileProcessingProgress } from '@newroom-connect/library/types';

/**
 * Base class for all file processing progress components.
 * Provides common functionality for handling progress data.
 */
@Directive()
export abstract class BaseProgressComponent {
  public readonly progressSignal = signal<IFileProcessingProgress | null>(null);

  @Input() public set progress(value: IFileProcessingProgress | null) {
    this.progressSignal.set(value);
  }

  /**
   * Computed filename with fallback.
   */
  public readonly filename = computed(() => this.progressSignal()?.filename || 'file');

  /**
   * Computed current processed count.
   */
  public readonly processed = computed(() => this.progressSignal()?.processed || 0);

  /**
   * Computed total count.
   */
  public readonly total = computed(() => this.progressSignal()?.total || 0);

  /**
   * Computed progress percentage.
   */
  public readonly percentage = computed(() => {
    const progress = this.progressSignal();

    if (!progress?.processed || !progress?.total) {
      return 0;
    }

    return Math.round((progress.processed / progress.total) * 100);
  });
}
